<fui-rows [label]="'Company'">
  <fui-content-layout-header-control slot="after">
    @if (!editing && model.canEdit(true)) {
      <fui-link-button [title]="'edit'"
      (click)="edit()"></fui-link-button>
    }
  </fui-content-layout-header-control>
  @if (data && formGroupCompany) {
    <fui-row [formGroup]="formGroupCompany">
      <fui-two-columns>
        <fui-column>
          <fui-text-control
            formControlName="name"
            [control]="formGroupCompany.get('name')"
            [label]="'fhm.company.name'"
            [placeholder]="'fhm.common.label.no-label'"
            [disabled]="!editing"
          [(ngModel)]="data.name"></fui-text-control>
        </fui-column>
        <fui-column>
          <fui-text-control
            formControlName="abn"
            [control]="formGroupCompany.get('abn')"
            [label]="'fhm.company.abn'"
            [placeholder]="'fhm.common.label.no-label'"
            [disabled]="!editing"
          [(ngModel)]="data.abn"></fui-text-control>
        </fui-column>
      </fui-two-columns>
    </fui-row>
    <fui-row [formGroup]="formGroupCompany">
      <fui-two-columns>
        <fui-column>
          <fui-text-control
            formControlName="phone"
            [control]="formGroupCompany.get('phone')"
            [label]="'fhm.company.phone'"
            [placeholder]="'fhm.common.label.no-label'"
            [disabled]="!editing"
          [(ngModel)]="data.phone"></fui-text-control>
        </fui-column>
        <fui-column>
          <fui-text-control
            [label]="'fhm.company.website'"
            [placeholder]="'fhm.common.label.no-label'"
            [disabled]="!editing"
            [ngModelOptions]="{standalone: true}"
          [(ngModel)]="data.website"></fui-text-control>
        </fui-column>
      </fui-two-columns>
    </fui-row>
  }
  @if (editing && !model.draft) {
    <fui-row>
      <fhm-action-buttons>
        @if (!newEntity) {
          <fhm-remove-button [title]="'fhm.common.button.cancel'"
          (clicked)="cancelEdit()"></fhm-remove-button>
        }
        <fhm-provision-button [title]="!newEntity ? 'fhm.common.button.save' : 'fhm.common.button.create'"
        (clicked)="save()"></fhm-provision-button>
      </fhm-action-buttons>
    </fui-row>
  }

</fui-rows>


